export const redirectToMainUrl = (): void => {
  const url = new URL(window.location.href);

  window.location.assign(`/?${url.searchParams.toString()}`);
};
